import { InjectionToken } from "@angular/core";
import { ILauncherRestClient } from "./i-launcher-rest.client";

export const launcherRestClientInjectionToken: InjectionToken<ILauncherRestClient> = new InjectionToken<ILauncherRestClient>("digital-signage.developer-dashboard.dashboard-web.LauncherRestClient");
